import footerLogo from '../website-logos/Brocon-Logo.svg';
import './footer.css';
import leedCert from '../website-logos/LEED-Certification-Logo.png'
// import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div>
      <div className="footer">
        <div className='sideBySideLeft'>
          <img src={footerLogo} className="brocon-logo-footer" alt="logo" />
          <img src={leedCert} className="leed-cert" alt="logo" />
        </div>
        <div className='sideBySideRight'>
          {/* <ul className='footerNav'>
          <li><Link to='/projects'>Our Work</Link></li>
          <li><Link to='/careers'>Careers</Link></li>
          <li><Link to='/projects'>Build To Suit</Link></li>
          <li><Link to='/our-team'>Our Team</Link></li>
          <li><Link to='/testimonials'>Testimonials</Link></li>
          <li><Link to='/divisons'>Divisions</Link></li>
        </ul> */}
          <div className='address'>
            <p>Brocon Construction Inc.</p>
            <p>2120 Hardy Parkway Street</p>
            <p>Grove City, Ohio 43123</p>
          </div>
          <div className='hours'>
            Monday - Friday: 8:00AM - 4:00PM EST
          </div>
          <div className='contactInfo'>
            <a href="tel:614-871-7300">614-871-7300</a> |
            <a href='mailto:info@brocon.net'> info@brocon.net</a>
          </div>
        </div>
      </div>
      <div className='extraBlueSpace'>
      </div>
    </div>
  );
}

export default Footer;
